import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    WARIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={WARIconImg} preview={false}/>
